import * as React from "react";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import MuiDrawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Link from "@mui/material/Link";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import NotificationsIcon from "@mui/icons-material/Notifications";

import logo from "../../icons/firstocklogo.svg";
import styles from "./dashboard.module.scss";
import { Outlet } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import icon1 from "../../icons/icon1.svg";
import icon2 from "../../icons/icon2.svg";
import icon3 from "../../icons/icon3.svg";
import icon4 from "../../icons/icon4.svg";

import { useLocation, useNavigate } from "react-router-dom";
import { LogoutAPICall, userDetailsAPICall } from "../../Shared/APIcalls";
// import Chart from "./Chart";
// import Deposits from "./Deposits";
// import Orders from "./Orders";

function Copyright(props: any) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://mui.com/">
        Your Website
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const drawerWidth: number = 240;

// interface AppBarProps extends MuiAppBarProps {
//   open?: boolean;
// }

// const AppBar = styled(MuiAppBar, {
//   shouldForwardProp: (prop) => prop !== "open",
// })<AppBarProps>(({ theme, open }) => ({
//   zIndex: theme.zIndex.drawer + 1,
//   transition: theme.transitions.create(["width", "margin"], {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   ...(open && {
//     marginLeft: drawerWidth,
//     width: `calc(100% - ${drawerWidth}px)`,
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   }),
// }));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: "100px",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(17),
      },
    }),
  },
}));

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

export default function Dashboard() {
  const [open, setOpen] = React.useState(true);
  const toggleDrawer = () => {
    setOpen(!open);
  };
  const navigate = useNavigate();
  const pathName = useLocation().pathname;

  const handleNagivate = (data: any) => {
    navigate(data);
  };

  const handleLogout = () => {
    LogoutAPICall()
      .then((response: any) => {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("userID");
        navigate("/login");
      })
      .catch((error: any) => {});
  };

  return (
    <div className={styles.mainwrapper}>
      <ThemeProvider theme={defaultTheme}>
        <div className={styles.leftsec}>
          <Box sx={{ display: "flex" }}>
            {/* <CssBaseline /> */}
 
            <div
        
              className={styles.drawreStyles}
            >
             
              <Toolbar
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                
              >
                <img
                  src={logo}
                  alt="logo"
                  className={styles.companylogo}
            
                />
              </Toolbar>
              {/* style={{ height: "90vh" }} */}
              <List component="nav">
                <React.Fragment>
                  <ListItemButton
                    onClick={() => {
                      handleNagivate("apiKeys");
                    }}
                    style={{
                      background: pathName.includes("apiKeys") ? "#B7ADF8" : "",
                      borderRadius: "10px",
                    }}
                  >
                    <ListItemIcon>
                      <img
                        src={icon1}
                        alt="icon1"
                        className={styles.listicon}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary="API Keys"
                      className={styles.listtext}
                    />
                  </ListItemButton>
                  <ListItemButton
                    className={styles.listbutton}
                    onClick={() => {
                      handleNagivate("profile");
                    }}
                    style={{
                      background: pathName.includes("profile") ? "#B7ADF8" : "",
                      borderRadius: "10px",
                    }}
                  >
                    <ListItemIcon>
                      <img
                        src={icon2}
                        alt="icon2"
                        className={styles.listicon}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary="Profile"
                      className={styles.listtext}
                    />
                  </ListItemButton>
                  <ListItemButton
                    className={styles.listbutton}
                    onClick={() => {
                      // handleNagivate("docs");
                      // window.open(
                      //   "https://connect.thefirstock.com/docsv3/docs/get-started/packages-instalation/",
                      //   "_blank"
                      // );
                      window.open("https://wikiconnect.thefirstock.com/","_blank")
                     // navigate("/docsv3");
                    }}
                    style={{
                      background: pathName.includes("docs") ? "#B7ADF8" : "",
                      borderRadius: "10px",
                    }}
                  >
                    <ListItemIcon>
                      <img
                        src={icon3}
                        alt="icon3"
                        className={styles.listicon}
                      />
                    </ListItemIcon>
                    <ListItemText primary="Docs" className={styles.listtext} />
                  </ListItemButton>
                  <ListItemButton
                    className={styles.listbutton}
                    style={{
                      borderRadius: "10px",
                    }}
                    onClick={handleLogout}
                  >
                    <ListItemIcon>
                      <img
                        src={icon4}
                        alt="icon4"
                        className={styles.listicon}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary="Logout"
                      className={styles.listtext}
                    />
                  </ListItemButton>
                </React.Fragment>
                {/* <Divider sx={{ my: 1 }} />
            {secondaryListItems} */}
              </List>
            </div>
           
          </Box>
        </div>
        <div className={styles.rightsec}>
          <Outlet />
        </div>
      </ThemeProvider>
    </div>
  );
}
